import { render } from "./FormattedDate.vue?vue&type=template&id=0d1cefd0&ts=true"
import script from "./FormattedDate.vue?vue&type=script&lang=ts"
export * from "./FormattedDate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__